module.exports = {
	"languages": {
		"fr": {
			"key": "fr-ca",
			"label": "Fr"
		},
		"en": {
			"key": "en-ca",
			"label": "En"
		}
	},
	"default": "fr",
	"messages": {
		"description": {
			"en": "Portfolio of Stéfanie Vermeersch, independent designer based in Montreal. Editorial, exhibition and signage design + other interdisciplinary projects.",
			"fr": "Portfolio de Stéfanie Vermeersch, designer indépendante établie à Montréal. Design d’édition, d’exposition, de système signalétique et autres projets interdisciplinaires."
		},
		"title": {
			"en": "Graphic and Environment Designer",
			"fr": "Designer graphique et de l’environnement"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n.json
// module id = 183
// module chunks = 0